export const rootStyle = () => ({
  background: 'transparent',
  border: 0,
  color: 'inherit',
  fontFamily: 'inherit',
  marginBottom: 2.5,
  cursor: 'pointer',
})

export const contentStyle = () => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 0.5
})

export const countStyle = () => ({
  color: 'text.secondary',
  textTransform: 'initial'
})
